<div style="display: flex">
  <div class="index">
    <div class="number" *ngFor="let item of items; let i = index">{{i}}</div>
  </div>
  <div cdkDropList class="sortable-list" (cdkDropListDropped)="drop($event)">
    <div class="item-box" *ngFor="let item of items" cdkDrag>{{item[1]}}</div>
  </div>
</div>
